import SrDInput from "./index.vue";

SrDInput.install = function(Vue) {
  Vue.component(SrDInput.name, SrDInput);
};

export default SrDInput;



// WEBPACK FOOTER //
// ./packages/SrDInput/index.js